import { FC, useState } from 'react';

import { useFormikContext } from 'formik';
import { compact } from 'lodash';
import { TagsField } from 'ui/components/form';
import { TagIcon } from 'ui/components/icon';
import { SIZE } from 'utils/constants';

import { EVENT_FORM } from '../schema';

const AddTag: FC = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { values, setFieldValue } = useFormikContext<EVENT_FORM>();

  return (
    <div className="flex items-center py-3">
      <TagIcon className="mr-4 h-5 w-5 text-content" />
      {isEditing || values.tagId?.length ? (
        <TagsField
          hideLabel
          size={SIZE.Small}
          defaultValue={compact(values.tagId)}
          onChange={(val) =>
            setFieldValue(
              'tagId',
              val.map((tag) => tag.value),
            )
          }
          className="w-full"
        />
      ) : (
        <button
          type="button"
          className="hover:text-secondary text-sm"
          onClick={() => setIsEditing(true)}
        >
          Add Tags
        </button>
      )}
    </div>
  );
};

export default AddTag;
